export const getLanguageDisplayName = (languageCode: string): string => {
    switch (languageCode.toUpperCase()) {
        case "FR":
            return "Français"; // French
        case "EN":
            return "English";
        case "ES":
            return "Español";
        case "DE":
            return "Deutsch";
        case "IT":
            return "Italiano";
        case "RU":
            return "Русский"; // Russian
        case "NA":
            return "N/A"; // Not Applicable or Not Available
        case "PT":
            return "Português"; // Portuguese
        case "PL":
            return "Polski"; // Polish
        case "NL":
            return "Nederlands"; // Dutch
        case "KR":
            return "한국어"; // Korean
        case "JP":
            return "日本語"; // Japanese
        case "CN":
        case "ZN":
        case "ZH":
            return "中文"; // Chinese
        case "HE":
            return "עברית"; // Hebrew
        case "AR":
            return "العربية"; // Arabic
        case "DA":
            return "Danish"; // Danish
        case "SV":
            return "Svenska"; // Swedish
        case "NO":
            return "Norsk"; // Norwegian
        case "EL":
        case "GR":
            return "Greek"; // Greek
        case "CA":
            return "Catalan"; // Catalan
        default:
            return "Unknown Language"; // Default case for unexpected language codes
    }
};

export {};
